<template>
  <div class="message-container">
    <div v-if="content" class="message-content">
      <FriedIcon :icon="content.icon" class="icon" />
      <FriedH4>{{ content.text }}</FriedH4>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import type { IconName } from '@getaccept/fried-tofu';
import { ChatUnavailableReason } from '../types';

export default defineComponent({
  props: {
    reason: {
      type: String as PropType<ChatUnavailableReason>,
      required: true,
    },
    companyName: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { t } = useI18n();

    const content = computed<{ icon: IconName; text: string }>(() => {
      switch (props.reason) {
        case ChatUnavailableReason.NotAMember:
          return {
            icon: 'conversation',
            text: t('dr_chat_unavailable_not_a_member'),
          };
        case ChatUnavailableReason.RemovedParticipant:
          return {
            icon: 'archive',
            text: t('dr_chat_unavailable_removed_participant'),
          };
        case ChatUnavailableReason.RemovedOwner:
          return {
            icon: 'archive',
            text: t('dr_chat_unavailable_removed_owner', {
              companyName: props.companyName,
            }),
          };
        default:
          return null;
      }
    });

    return {
      content,
    };
  },
});
</script>

<style lang="scss" scoped>
.message-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--gray-98);
  border: 1px solid var(--gray-89);
  border-radius: var(--radius-medium);
  margin: var(--spacing-50) var(--spacing-50) var(--spacing-100) var(--spacing-50);
  padding: var(--spacing-100);

  .message-content {
    display: flex;
    gap: var(--spacing-50);

    .icon {
      flex-shrink: 0;
    }
  }
}
</style>
